import React from 'react';
import { BookOpen, RotateCcw, Settings, BookMarked } from 'lucide-react';
import { ActionCard } from '../components/ActionCard';
interface HomeProps {
  onStartLesson: () => void;
  onOpenDictionary: () => void;
  onStartReview: () => void;
  reviewCount: number;
}
export function Home({
  onStartLesson,
  onOpenDictionary,
  onStartReview,
  reviewCount
}: HomeProps) {
  return <div className="min-h-screen bg-[#FDFBF7] text-gray-800 font-sans selection:bg-[#E63946] selection:text-white" data-id="element-82">
      <main className="max-w-md mx-auto px-6 py-12 min-h-screen flex flex-col" data-id="element-83">
        {/* Header */}
        <header className="flex justify-between items-center mb-12" data-id="element-84">
          <div data-id="element-85">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900" data-id="element-86">
              Doshi
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-87">
              Japanese vocabulary learning
            </p>
          </div>
          <button className="p-2 rounded-full bg-gray-100 transition-colors text-gray-500 hover:bg-gray-200" aria-label="Settings" data-id="element-88">
            <Settings size={28} data-id="element-89" />
          </button>
        </header>

        {/* Actions Section */}
        <section className="space-y-4" data-id="element-90">
          <ActionCard title="Learn New Words" subtitle="5 new words available today" icon={BookOpen} primary={true} delay={0.2} onClick={onStartLesson} data-id="element-91" />

          <ActionCard title="Review" subtitle={reviewCount > 0 ? `${reviewCount} words due for review` : 'No words to review'} icon={RotateCcw} delay={0.3} onClick={onStartReview} data-id="element-92" />

          <ActionCard title="Dictionary" subtitle="See all 14 words" icon={BookMarked} delay={0.4} onClick={onOpenDictionary} data-id="element-93" />
        </section>
      </main>
    </div>;
}